import React from "react";
import { StarIcon } from "lucide-react";
import { STAR_REVIEWS } from "../lib/data";
export function StarReviews() {
  return <section className="px-4 py-6" data-id="element-177" data-mp="2u3ornsj9ct4y">
      <div className="space-y-3" data-id="element-178" data-mp="2u0sx8e6mcml9">
        {STAR_REVIEWS.map(r => <article key={r.name} className="rounded-xl bg-white p-4 shadow-lg" data-id="element-179" data-mp="2z0xbdxk2158b">
            <div className="flex gap-0.5" data-id="element-180" data-mp="33v1h6dhl377t">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-181" data-mp="38ue571k6ykbz" data-mpi={i} />)}
            </div>
            <p className="mt-2 text-sm leading-snug text-slate-700" data-id="element-182" data-mp="3hszleq26xn9l">"{r.text}"</p>
            <p className="mt-2 text-xs font-bold text-[#0f2c4a]" data-id="element-183" data-mp="3hqwy4dsfa88k">
              {r.name} <span className="font-normal text-slate-400" data-id="element-184" data-mp="3mr1em3tbz2ys">· {r.location}</span>
            </p>
          </article>)}
      </div>
    </section>;
}